// extracted by mini-css-extract-plugin
export var black = "_3z-6";
export var brand = "_3z-1";
export var ddefault = "_3z-0";
export var error = "_3z-3";
export var gray = "_3z-2";
export var highContrast = "_3z-8";
export var outline = "_3z-7";
export var success = "_3z-5";
export var warning = "_3z-4";